import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import authHeader from "./authHeader";
import { apiInstance } from "./axiosApi";

export const getContestWiseEarning = createAsyncThunk(
  "admin/getContestWiseEarning",
  async ({ startDate = null, endDate = null } = {},{ rejectWithValue }) => {
    const params = {};
    if (startDate || endDate) {
      params.dateFilter = {};
      if (startDate) params.dateFilter.startDate = startDate;
      if (endDate) params.dateFilter.endDate = endDate;
    }
    try {
      const response = await apiInstance.get(`/earning/contest-wise`, {
        headers: authHeader(),
        params
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const getSlotTimeEarning = createAsyncThunk(
  "admin/getSlotTimeEarning",
  async ({ startDate = null, endDate = null } = {},{ rejectWithValue }) => {
    const params = {};
    if (startDate || endDate) {
      params.dateFilter = {};
      if (startDate) params.dateFilter.startDate = startDate;
      if (endDate) params.dateFilter.endDate = endDate;
    }
    try {
      const response = await apiInstance.get(`/earning/slot-wise`, {
        headers: authHeader(),
        params
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const getUserEarning = createAsyncThunk(
  "admin/getUserEarning",
  async ({ startDate = null, endDate = null } = {},{ rejectWithValue }) => {
    const params = {};
    if (startDate || endDate) {
      params.dateFilter = {};
      if (startDate) params.dateFilter.startDate = startDate;
      if (endDate) params.dateFilter.endDate = endDate;
    }
    try {
      const response = await apiInstance.get(`/earning/user-wise`, {
        headers: authHeader(),
        params
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const getSubjectEarning = createAsyncThunk(
  "admin/getSubjectEarning",
  async ({ startDate = null, endDate = null } = {},{ rejectWithValue }) => {
    const params = {};
    if (startDate || endDate) {
      params.dateFilter = {};
      if (startDate) params.dateFilter.startDate = startDate;
      if (endDate) params.dateFilter.endDate = endDate;
    }
    try {
      const response = await apiInstance.get(`/earning/subject-wise`, {
        headers: authHeader(),
        params
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const getClassesEarning = createAsyncThunk(
  "admin/getClassesEarning",
  async ({ startDate = null, endDate = null } = {},{ rejectWithValue }) => {
    const params = {};
    if (startDate || endDate) {
      params.dateFilter = {};
      if (startDate) params.dateFilter.startDate = startDate;
      if (endDate) params.dateFilter.endDate = endDate;
    }
    try {
      const response = await apiInstance.get(`/earning/classes-wise`, {
        headers: authHeader(),
        params
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const initialState = {
    contestWiseData: [],
    slotTimeData:[],
    userWiseData:[],
    subjectWiseData:[]
  };
  
  const contestEarningSlice = createSlice({
    name: "contestEarningSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
      builder.addCase(getContestWiseEarning.fulfilled, (state, action) => {
        state.contestWiseData = action.payload.data;
      });
      builder.addCase(getSlotTimeEarning.fulfilled, (state, action) => {
        state.slotTimeData = action.payload.data;
      });
      builder.addCase(getUserEarning.fulfilled, (state, action) => {
        state.userWiseData = action.payload.data;
      });
      builder.addCase(getSubjectEarning.fulfilled, (state, action) => {
        state.subjectWiseData = action.payload.data;
      });
      builder.addCase(getClassesEarning.fulfilled, (state, action) => {
        state.classesEarningData = action.payload.data;
      });
    },
  });
  export default contestEarningSlice.reducer;